import api from '@/services/Api';

export default {
  validateUrl(url) {
    return api()
      .get('/validate-app-url?' + new URLSearchParams({ url }))
      .then(resp => resp);
  },
};
